var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Watch, PropertyConverters, P, Utils } from '@pacem/pacem-core';
import { UiElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
//namespace Pacem.Components.Drawing {
let PacemTextElement = class PacemTextElement extends UiElement {
    propertyChangedCallback(name, old, val, first) {
        if (!first) {
            switch (name) {
                case 'text':
                case 'color':
                case 'fontFamily':
                case 'fontSize':
                case 'fontWeight':
                case 'fontStyle':
                case 'anchor':
                    if (!Utils.isNull(this.stage)) {
                        this.stage.draw(this);
                    }
                    break;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTextElement.prototype, "text", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTextElement.prototype, "color", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTextElement.prototype, "fontFamily", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTextElement.prototype, "fontSize", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTextElement.prototype, "fontWeight", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTextElement.prototype, "fontStyle", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemTextElement.prototype, "anchor", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemTextElement.prototype, "textAnchor", void 0);
PacemTextElement = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-text' })
], PacemTextElement);
export { PacemTextElement };
